import useApiResult from './useApiResult';
import { getDeliveryMethods } from './apiRequests';

const useGetDeliveryMethods = async () => {
  const request = getDeliveryMethods();
  const response = await useApiResult(request);

  if (!response || response[1]) {
    return response;
  }

  if (response[0]) {
    const { Data } = response[0];
    return [Data, response[1]];
  }

  return response;
};

export default useGetDeliveryMethods;